import React from 'react'
import { Box, BoxProps } from '@material-ui/core'

type Props = BoxProps & {
  children: React.ReactNode
}

export function FormGroup({ children, ...props }: Props): React.ReactElement {
  return (
    <Box mb={2} {...props}>
      {children}
    </Box>
  )
}
